// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"searchContainer__3IR7L","inputContainer":"inputContainer__2W7wI","clearIcon":"clearIcon__1yFur","loadingContainer":"loadingContainer__1zdRe"};